import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: {},
      popAdvShow: false,
      condition: {
        "game_type": "sheep",
        "time_period": 0
      },
      isLoading: false
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/game/score/list", {
        ...this.condition
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data;
      }
    },
    async onCreate() {
      this.modifyData = {
        "icon": "",
        'status': "1",
        "provider": 'adsgram',
        'verifiable': "0",
        "cyclical": "0",
        "limit_count": "0"
      };
      this.popAdvShow = true;
    },
    async onModify(item) {
      this.modifyData = item;
      this.popAdvShow = true;
    },
    async onCopy(item) {
      this.modifyData = Object.assign({}, item);
      delete this.modifyData.id;
      this.popAdvShow = true;
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  }
};